// pages/PaymentSuccess.jsx
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { subscriptionProcessPayment } from "../hooks/services/api-services";
import { toastEmitter } from "../utils/utilities";

const PaymentSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token"); // PayPal orderId / transactionId

  useEffect(() => {
    const completePayment = async () => {
      const planData = JSON.parse(localStorage.getItem("selectedSubscription"));

      if (!token || !planData) {
        toastEmitter("error", "Missing payment or plan details.");
        return;
      }

      const payload = {
        walletAmountUsed: 0,
        id: 0,
        transactionId: token,
        payerEmail: "unknown@paypal.com", // you can fetch it from backend later
        subscriptionId: planData.subscriptionId,
        userType: planData.userType,
        subscriptionDuration: planData.subscriptionDuration,
      };

      try {
        const res = await subscriptionProcessPayment(payload);
        if (res?.data?.status === 200) {
          toastEmitter("success", "✅ Payment processed successfully!");
          localStorage.removeItem("selectedSubscription");
          setTimeout(() => navigate("/pricing"), 1500);
        } else {
          toastEmitter("error", res?.data?.message || "❌ Payment failed.");
        }
      } catch (err) {
        console.error("Process Payment Error", err);
        toastEmitter("error", "❌ Something went wrong.");
      }
    };

    completePayment();
  }, []);

  return (
    <div className="container py-5 text-center">
      <h3>Processing your payment...</h3>
    </div>
  );
};

export default PaymentSuccess;
